"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var react_device_detect_1 = require("react-device-detect");

var classnames_1 = __importDefault(require("classnames"));

require("./Header.scss");

exports.Header = function (_a) {
  var srcLogo = _a.srcLogo,
      currentBrandCode = _a.currentBrandCode,
      labelClose = _a.labelClose,
      btnProps = _a.btnProps,
      title = _a.title,
      _b = _a.styleProps,
      styleProps = _b === void 0 ? {
    width: 'auto',
    height: 'auto',
    maxHeight: '44px'
  } : _b;
  return react_1.default.createElement(react_theme_components_1.SzHeader, {
    className: "sz-header-global justify-content-between py-1 d-flex px-2",
    bg: "light"
  }, react_1.default.createElement("a", {
    href: "/",
    style: {
      maxWidth: 170,
      minWidth: 140
    },
    className: "d-flex align-items-center pl-2"
  }, react_1.default.createElement("img", {
    className: "py-1",
    style: styleProps,
    src: srcLogo,
    alt: currentBrandCode
  })), title && react_device_detect_1.isBrowser && react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "h1",
    color: "dark",
    weight: "regular",
    className: classnames_1.default('my-auto d-none d-sm-flex', {
      'mx-auto pr-5': !labelClose
    }),
    align: "center"
  }, title), labelClose && react_1.default.createElement(react_theme_components_1.SzButton, __assign({
    variant: "tertiary",
    icon: "close",
    alignIcon: "right"
  }, btnProps), react_device_detect_1.isBrowser && labelClose));
};

exports.default = exports.Header;